import React, { useEffect, useState } from 'react';
import bg_image_1 from '../assets/bg_image_1.jpg';
import pattern_1 from '../assets/pattern_1.png';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';
import { FaFacebookF } from 'react-icons/fa';
import { TiSocialLinkedin } from 'react-icons/ti';
import { FaTwitter } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import useToken from '../context/useToken';
import axios from 'axios';

const Footer = () => {
  const token = useToken();
  const [title, setTitle] = useState("Let's get to work");
  const [subtitle, setSubtitle] = useState("Ready to do this");
  const [image, setImage] = useState(pattern_1);
  const [showModal, setShowModal] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const [newSubtitle, setNewSubtitle] = useState(subtitle);
  const [newImage, setNewImage] = useState(null);

  const fetchFooterData = async () => {
    try {
      const response = await axios.get('https://thecfagroup.org/v1/api/footer', {
        headers: {
          'accept': '*/*',
        },
      });

      if (response?.data) {
        const latestData = response.data[response.data.length - 1];
        setTitle(latestData.title || "Let's get to work");
        setSubtitle(latestData.subtitle || "Ready to do this");
        setImage(latestData.bg_image || pattern_1);
      }
    } catch (error) {
      console.error('Error fetching footer data:', error);
    }
  };

  useEffect(() => {
    fetchFooterData();
  }, []);

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', newTitle);
    formData.append('subtitle', newSubtitle);
    formData.append('cta_text', '');
    formData.append('cta_link', '');
    formData.append('cta_color', '');
    formData.append('isButtonActive', true);

    if (newImage) {
      formData.append('image', newImage, newImage.name);
    }
    // else
    // formData.append('image', "","");

    try {
      await axios.post('https://thecfagroup.org/v1/api/footer', formData, {
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      setTitle(newTitle);
      setSubtitle(newSubtitle);
      if (newImage) setImage(URL.createObjectURL(newImage));
      setShowModal(false);
    } catch (error) {
      console.error('Error updating footer:', error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
    }
  };

  return (
    <div>
      <div className="relative flex items-center justify-center h-[55vh] px-4">
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'linear-gradient(145deg, #25a182, #0e7a58, #a5d6a7)',
          }}
        ></div>

        <div
          className="absolute inset-0 z-10 opacity-60"
          style={{
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'repeat',
            backgroundSize: 'contain',
          }}
        ></div>

        <div className="relative z-20 flex flex-col items-center justify-center p-12 rounded-md">
          <h4 className="text-[#fff] font-poppinsRegular text-base uppercase tracking-widest mb-2">
            {subtitle}
          </h4>
          <h1 className="flex items-center gap-10 text-[#fff] text-[75px] md:text-7xl font-black mb-10 text-center">
            {title}
            {token && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-14 h-14 cursor-pointer mt-2"
                onClick={() => setShowModal(true)}
              >
                <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
              </svg>
            )}
          </h1>
          <Link to="/contact">
            <button className="text-[#fff] border-2 border-white px-10 mt-2 py-3 text-lg rounded hover:bg-white hover:text-[#25a182] transition-transform duration-300 transform hover:translate-y-[-4px]">
              Contact us
            </button>
          </Link>
        </div>
      </div>

      <div className="w-full bg-[#00010c] relative">
        <div className="absolute inset-0 bg-gradient-to-r from-black via-transparent to-black opacity-70">
          <img src={bg_image_1} alt="" className="w-full h-full object-cover opacity-50" />
        </div>

        <div className="relative z-10 flex flex-col md:flex-row justify-between items-center w-full mx-auto p-4 space-y-4 md:space-y-0 md:space-x-8">
          <div className="flex items-center w-full md:w-auto justify-center md:justify-start">
            <img src={logo} alt="Trydo Logo" className="h-[4rem] mr-3" />
          </div>

          <div className="flex space-x-4 justify-center items-center w-full md:w-auto md:pl-[9rem]">
            <Link to="https://facebook.com" target="_blank" rel="noreferrer" className="text-[#c6c9d8] text-xl border border-[#c6c9d8] rounded-full p-2 hover:bg-[#25a182] hover:border-opacity-30 duration-300 transform hover:translate-y-[-4px]">
              <FaFacebookF />
            </Link>
            <Link to="https://linkedin.com" target="_blank" rel="noreferrer" className="text-[#c6c9d8] text-xl border border-[#c6c9d8] rounded-full p-2 hover:bg-[#25a182] hover:border-opacity-30 duration-300 transform hover:translate-y-[-4px]">
              <TiSocialLinkedin />
            </Link>
            <Link to="https://instagram.com" target="_blank" rel="noreferrer" className="text-[#c6c9d8] text-xl border border-[#c6c9d8] rounded-full p-2 hover:bg-[#25a182] hover:border-opacity-30 duration-300 transform hover:translate-y-[-4px]">
              <FaInstagram />
            </Link>
            <Link to="https://twitter.com" target="_blank" rel="noreferrer" className="text-[#c6c9d8] text-xl border border-[#c6c9d8] rounded-full p-2 hover:bg-[#25a182] hover:border-opacity-30 duration-300 transform hover:translate-y-[-4px]">
              <FaTwitter />
            </Link>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white rounded p-8 w-96">
            <h2 className="text-xl font-bold mb-4">Edit Footer</h2>
            <form onSubmit={handleEditSubmit}>
              <label className="block mb-2">
                Title
                <input
                  type="text"
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                  className="border rounded w-full p-2"
                />
              </label>
              <label className="block mb-2">
                Subtitle
                <input
                  type="text"
                  value={newSubtitle}
                  onChange={(e) => setNewSubtitle(e.target.value)}
                  className="border rounded w-full p-2"
                />
              </label>
              <label className="block mb-2">
                Background Image
                <input
                  type="file"
                  onChange={handleImageChange}
                  className="border rounded w-full p-2"
                />
              </label>
              <div className="flex justify-end space-x-4 mt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#25a182] text-white rounded"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
